import React from 'react';
import {
  Box,
  Button,
  // Container,
  // Divider,
  Paper,
  Typography,
} from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { useHistory, withRouter } from 'react-router'; // import the react-router-dom components
import TranslatedText from '../../components/atoms/translated_text';
import RemindersMsidReceivedActions from '../../redux/reducers/reminders_msid_received_list_reducer/actions';
import useStyles from './styles';
import RemindersMsidReceivedDatatableList from './components/datatable';
import clsx from 'clsx';
import NotificationImportantOutlinedIcon from '@material-ui/icons/NotificationImportantOutlined';
import { Translations } from './configuration';
import { RemindersMsidReceivedTableDefaultFetchValues } from './components/datatable/configuration';
import NavigationConfig from 'navigation/config';
import RemindersMsidReceivedListActions from 'redux/reducers/reminders_msid_received_list_reducer/actions';
import useQuery from 'custom_hooks/useQuery';

const RemindersMsidReceivedPage = (props: any) => {
  // console.log('Render RemindersMsidReceived Page');
  const dispatch = useDispatch();
  const classes = useStyles();

  const query = useQuery();
  const vat_num = query.get('vat_num');
  const originatingCountry = query.get('originatingCountry');
  const schemeType = query.get('schemeType');
  let searchParams = {
    ...(vat_num && { vat_num }),
    ...(originatingCountry && { originatingCountry }),
    ...(schemeType && { schemeType }),
  };

  React.useEffect(() => {
    dispatch(
      RemindersMsidReceivedListActions.fetchMemberStateExcludeCyprusAction()
    );
  }, [dispatch]);

  React.useEffect(() => {
    dispatch(RemindersMsidReceivedActions.fetchUnreadNotificationCountAction());
  }, [dispatch]);

  React.useEffect(() => {
    dispatch(
      RemindersMsidReceivedActions.fetchRemindersMsidReceivedListAction({
        sortField:
          RemindersMsidReceivedTableDefaultFetchValues.TABLE_DEFAULT_SORT_KEY,
        page: RemindersMsidReceivedTableDefaultFetchValues.TABLE_DEFAULT_PAGE,
        pageSize:
          RemindersMsidReceivedTableDefaultFetchValues.TABLE_DEFAULT_PAGE_SIZE,
        order: RemindersMsidReceivedTableDefaultFetchValues.TABLE_DEFAULT_ORDER,
        ...searchParams,
      })
    );
  }, [dispatch, searchParams]);

  return (
    /*================== RemindersMsidReceived Page ==================*/
    <div>
      {/*================== RemindersMsidReceived Page - Header ==================*/}
      <Paper
        className={clsx(classes.titleLayout)}
        elevation={0}
        variant={'outlined'}
        square
      >
        {/* RemindersMsidReceived Page - Header - Title, Icon & Actions */}
        <Box display="flex" alignItems={'center'}>
          {/* Icon */}
          <NotificationImportantOutlinedIcon
            style={{ marginRight: '.75rem' }}
          />
          {/* Title */}
          <Typography component={'p'} variant={'h6'}>
            <TranslatedText
              textMap={Translations.page_title}
              defaultText={Translations.page_title.English}
            />
          </Typography>
        </Box>
      </Paper>
      {/*--------------- end of RemindersMsidReceived Page - Header ---------------*/}

      {/*================== RemindersMsidReceived Page - Body ==================*/}
      <div style={{ padding: 12 }}>
        {/*================== RemindersMsidReceived Page - Body - RemindersMsidReceived Section ==================*/}
        <div className={classes.cardLayout}>
          {/* RemindersMsidReceived Page - Body - RemindersMsidReceived Section - Title */}
          <Typography
            component={'p'}
            variant={'h5'}
            style={{ marginBottom: '.5rem' }}
          >
            <TranslatedText
              textMap={Translations.title}
              defaultText={Translations.title.English}
            />
          </Typography>

          {/* RemindersMsidReceived Page - Body - RemindersMsidReceived Section - Description */}
          <Typography component={'p'} variant={'subtitle1'}>
            <TranslatedText
              textMap={Translations.description}
              defaultText={Translations.description.English}
            />
          </Typography>

          {/* RemindersMsidReceived Page - Body - RemindersMsidReceived Section - RemindersMsidReceived List Table */}
          <div className={classes.tableList}>
            <RemindersMsidReceivedDatatableList />
          </div>

          {/* RemindersMsidReceived Page - Body - RemindersMsidReceived Section - Buttons & Actions */}
          <Box display="flex" justifyContent="flex-end">
            <div className={classes.dashboardButton}>
              <BackToDashboardPage />
            </div>
          </Box>
        </div>
        {/*--------------- end of RemindersMsidReceived Page - Body - RemindersMsidReceived Section ---------------*/}
      </div>
      {/*--------------- end of RemindersMsidReceived Page - Body ---------------*/}
    </div>
    /*--------------- end of RemindersMsidReceived Page ---------------*/
  );
};

const BackToDashboardPage = () => {
  const history = useHistory();
  const goToDashboard = () => {
    history.push(NavigationConfig.dashboardPage().path);
  };

  return (
    <Button
      variant="contained"
      style={{ color: '#e6e6e6', backgroundColor: '#25262d' }}
      onClick={goToDashboard}
    >
      <TranslatedText textMap={Translations.go_to_dashboard} />
    </Button>
  );
};

export default withRouter(RemindersMsidReceivedPage);
